import { HoneyGridIcon } from '@/icons'
import { type GridVersion } from 'honeygrid-types'

import type { FC } from 'react'

interface TargetingAreasMetricRowProps {
	grid_version?: GridVersion
}

export const TargetingAreasMetricRow: FC<TargetingAreasMetricRowProps> = ({ grid_version }) => {
	if (!grid_version) return null

	const numFilters = Object.keys(grid_version.targeting_filters).length
	const filtersLabel = numFilters === 1 ? 'filter' : 'filters'

	let targetedAreasLabel = ''

	if (grid_version.targeting_type === 'county') {
		const countyCount = grid_version.targeted_areas?.counties?.length ?? 0
		targetedAreasLabel = `${countyCount} ${countyCount === 1 ? 'county' : 'counties'}`
	} else if (grid_version.targeting_type === 'zip code') {
		const zipCount = grid_version.targeted_areas?.zipCodes?.length ?? 0
		targetedAreasLabel = `${zipCount} ${zipCount === 1 ? 'zip code' : 'zip codes'}`
	} else if (grid_version.targeting_type === 'radius') {
		const radius = grid_version.targeted_areas?.coordinates?.[0]?.radius ?? 0
		targetedAreasLabel = `${radius} miles`
	}

	return (
		<div className="flex items-center gap-2">
			<HoneyGridIcon className="h-4 w-4" />
			<p className="text-sm">
				{targetedAreasLabel} ({`${numFilters} ${filtersLabel}`})
			</p>
		</div>
	)
}
